export default function joinClassName() {
    var arg = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arg[_i] = arguments[_i];
    }
    if (arg.length === 1)
        return (arg[0]) ? '' + arg[0] : '';
    return arg.filter(function (i) { return i; }).join(' ');
}
